import api from "@/lib/axios";

export const createCheckoutSession = async (planName: string) => {
  const res = await api.post("/stripe/create-checkout-session", { planName });
  return res.data as { url: string };
};

export const createTopupSession = async (credits: number) => {
  const res = await api.post("/stripe/create-topup-session", { credits });
  return res.data as { url: string };
};

export const createProxyTopupSession = async (bandwidthMb: number) => {
  const res = await api.post("/stripe/create-proxy-topup-session", { bandwidthMb });
  return res.data as { url: string };
};

export interface ProxyTopupPackage {
  label: string;
  bandwidthMb: number;
  priceCents: number;
}

export const fetchProxyTopupPackages = async (): Promise<ProxyTopupPackage[]> => {
  const res = await api.get("/stripe/proxy-topup-packages");
  return res.data.data;
};

export const cancelSubscription = async (feedback?: { reason?: string; details?: string }) => {
  const res = await api.post("/stripe/cancel-subscription", feedback ?? {});
  return res.data;
};

export const reactivateSubscription = async () => {
  const res = await api.post("/stripe/reactivate-subscription");
  return res.data;
};

export interface CatalogPlan {
  name: string;
  priceCents: number;
  currency: string;
  includedCredits: number | null;
  proxyBandwidthMb: number;
}

export const fetchPlanCatalog = async (): Promise<CatalogPlan[]> => (await api.get("/stripe/plans")).data.data;

export interface PlanChangePreview {
  direction: "upgrade" | "downgrade";
  from: string;
  to: string;
  dueTodayCents: number;
  currency: string;
  newPriceCents: number | null;
  renewsAt?: string | null;
  effectiveAt?: string | null;
  prorationDate?: number;
}

export const previewPlanChange = async (planName: string): Promise<PlanChangePreview> =>
  (await api.post("/stripe/change-plan", { planName })).data;

export const confirmPlanChange = async (
  planName: string,
  prorationDate?: number
): Promise<{ direction: "upgrade" | "downgrade"; status: "done" | "scheduled"; plan: string; effectiveAt?: string; paidCents?: number | null }> =>
  (await api.post("/stripe/change-plan", { planName, confirm: true, prorationDate }, { timeout: 60_000 })).data;

export const keepCurrentPlan = async () => (await api.post("/stripe/cancel-plan-change")).data;

export const createPortalSession = async () => {
  const res = await api.post("/stripe/portal-session");
  return res.data as { url: string };
};
